export type RoleAwareUser = {
  role?: string | null;
  organization_role?: string | null;
  active_organization_id?: number | string | null;
  organization_id?: number | string | null;
};

function normalizeRole(role?: string | null): string {
  return String(role || '').trim().toLowerCase();
}

export function isSuperAdminUser(user: RoleAwareUser | null | undefined): boolean {
  return normalizeRole(user?.role) === 'superadmin';
}

export function isActiveOrganizationAdmin(user: RoleAwareUser | null | undefined): boolean {
  return normalizeRole(user?.organization_role) === 'admin';
}

export function canAccessAdminArea(user: RoleAwareUser | null | undefined): boolean {
  return isSuperAdminUser(user) || isActiveOrganizationAdmin(user);
}

export function canCreateProject(user: RoleAwareUser | null | undefined): boolean {
  if (!isSuperAdminUser(user)) {
    return true;
  }
  return Number(user?.active_organization_id || user?.organization_id || 0) > 0;
}
